import ExistToken from '@/routes/middlewares/existToken';

export default [{
        path: '/',
        component: () =>
            import ('./../views/Home.vue'),
        props: {
            template: 'dashboard',
            middlewares: [ExistToken]
        },
    },
    {
        path: '/home',
        component: () =>
            import ('./../views/Home.vue'),
        props: {
            template: 'complete',
            middlewares: [ExistToken]
        },
    },
    {
        path: '*',
        component: () =>
            import ( /* webpackChunkName: "error404" */ '@/views/errors/404.vue'),
        props: {
            template: 'complete',
        },
    },
];